import { Button } from '@base-ui/react/button';
import { Chevron } from 'component-library';
import { styles } from './styles';
import type { MouseEvent } from 'react';

type DropdownToggleButtonProps = {
  label: string;
  isExpanded: boolean;
  onToggle: () => void;
};

export function DropdownToggleButton({ label, isExpanded, onToggle }: DropdownToggleButtonProps) {
  const handleMouseDown = (event: MouseEvent<HTMLButtonElement>) => {
    // Prevent Combobox.Item from taking focus/selecting on toggle press.
    event.preventDefault();
    event.stopPropagation();
  };

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    // Keep expansion separate from selection behavior.
    event.preventDefault();
    event.stopPropagation();
    onToggle();
  };

  return (
    <Button
      css={styles.ToggleButton}
      aria-label={`Toggle ${label}`}
      aria-expanded={isExpanded}
      onMouseDown={handleMouseDown}
      onClick={handleClick}
    >
      <Chevron width="24px" height="24px" rotation={isExpanded ? 180 : 0} />
    </Button>
  );
}
